// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__2zfVr","col":"styles_col__3SsPQ"};